import { Utilities } from "./utilities";

export class ArrayUtilities {
  // Function areArraysEqual that takes two arrays as arguments and returns true if the arrays are equal
  static areArraysEqual(array1: any[], array2: any[]): boolean {
    if (array1?.length !== array2?.length) {
      return false;
    }

    for (let i = 0; i < array1?.length; i++) {
      if (typeof array1[i] === "object" && typeof array2[i] === "object") {
        if (!Object.keys(array1[i]).every((key) => array1[i][key] === array2[i][key])) {
          return false;
        }
      } else if (array1[i] !== array2[i]) {
        return false;
      }
    }

    return true;
  }

  // Sort array of objects by key
  static sortArray<T>(array: T[], titleGetter: (t: T) => string): T[] {
    return array.sort((a, b) => {
      return (Utilities.removeEmojis(titleGetter(a)) + "")
        .trim()
        .toLowerCase()
        .localeCompare((Utilities.removeEmojis(titleGetter(b)) + "").trim().toLowerCase());
    });
  }

  /**
   *  Function to convert array to multi-dimensional array
   * @param array The array to convert
   * @param size The size of the sub-arrays
   * @returns The multi-dimensional array
   * @deprecated use lodash chunk instead
   */
  static arrayToMultiDimensional<T>(array: T[], size: number): T[][] {
    const result: T[][] = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  }

  static filteredNotUndefined<T>(array: (T | undefined)[]): T[] {
    const filteredArr: T[] = [];
    array.forEach((arrayVal) => {
      if (arrayVal !== undefined) {
        filteredArr.push(arrayVal);
      }
    });

    return filteredArr;
  }
}

export const sortWithoutEmojis = (a: string, b: string): number => {
  return Utilities.removeEmojis(a).toString().toLowerCase().localeCompare(Utilities.removeEmojis(b).toString().toLowerCase());
};

/**
 * Function to sort two strings naturally. If they are similar except for numbers, it will sort by the numbers.
 * It also sorts without emojis.
 * @param a The first string to compare
 * @param b The second string to compare
 */
export const sortNatural = (a: string, b: string): number => {
  const aWithoutEmojis = Utilities.removeEmojis(a) + "";
  const bWithoutEmojis = Utilities.removeEmojis(b) + "";

  const aWithoutEmojisAndNumbers = aWithoutEmojis.replace(/\d/g, "");
  const bWithoutEmojisAndNumbers = bWithoutEmojis.replace(/\d/g, "");

  if (aWithoutEmojisAndNumbers === bWithoutEmojisAndNumbers) {
    const aNumbers = aWithoutEmojis.match(/\d+/g);
    const bNumbers = bWithoutEmojis.match(/\d+/g);

    if (aNumbers && bNumbers) {
      const aNumber = parseInt(aNumbers[0]);
      const bNumber = parseInt(bNumbers[0]);

      return aNumber - bNumber;
    }
  }

  return aWithoutEmojisAndNumbers.localeCompare(bWithoutEmojisAndNumbers);
};

export const convertOptionalArrayToArray = <T>(array: T[] | T | undefined): T[] => {
  if (array === undefined) {
    return [];
  }

  if (Array.isArray(array)) {
    return array;
  }

  return [array];
};

export const getStringArray = (value: any): string[] => {
  if (Array.isArray(value)) {
    return value.map((v) => "" + v);
  } else if (typeof value === "string") {
    return [value];
  }
  return [];
};
